<div class="modal-header">
  <h5 class="modal-title">
    <i class="bi bi-plus-circle me-2"></i>
    {{ 'TenantGroupManagement.createGroup' | translate }}
  </h5>
  <button type="button" class="btn-close" [disabled]="saving" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="groupForm">
    <!-- Group Name -->
    <div class="mb-3">
      <label class="form-label required">
        {{ 'TenantGroupManagement.groupName' | translate }}
      </label>
      <input type="text" 
             class="form-control" 
             formControlName="groupName"
             [class.is-invalid]="groupForm.get('groupName')?.invalid && groupForm.get('groupName')?.touched"
             maxlength="100"
             placeholder="{{ 'TenantGroupManagement.groupNamePlaceholder' | translate }}">
      <div class="invalid-feedback" *ngIf="groupForm.get('groupName')?.invalid && groupForm.get('groupName')?.touched">
        <div *ngIf="groupForm.get('groupName')?.errors?.['required']">
          {{ 'Validation.required' | translate }}
        </div>
        <div *ngIf="groupForm.get('groupName')?.errors?.['maxlength']">
          {{ 'Validation.maxLength' | translate: {max: 100} }}
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="mb-3">
      <label class="form-label">
        {{ 'TenantGroupManagement.description' | translate }}
      </label>
      <textarea class="form-control" 
                formControlName="description"
                rows="3"
                maxlength="500"
                placeholder="{{ 'TenantGroupManagement.descriptionPlaceholder' | translate }}"></textarea>
      <div class="form-text">
        {{ 'General.optional' | translate }}
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-secondary" 
          [disabled]="saving"
          (click)="cancel()">
    {{ 'General.cancel' | translate }}
  </button>
  <button type="button" 
          class="btn btn-primary" 
          [disabled]="saving || groupForm.invalid"
          (click)="save()">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    {{ 'General.save' | translate }}
  </button>
</div>
